<template>
  <div class="text-algin height">
    <div class="block">
      <el-pagination
        background
        :total="totalCount"
        :page-size.sync="pagination.pageSize"
        :current-page.sync="pagination.pageNumber"
        layout="pager"
        @current-change="handlePageNumberChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
const EVENT_PAGING = "on-paging"

export default {
  name: "Pagination",
  props: {
    pageSize: Number,    // 一页数据的条数
    totalCount: Number,  // 总件数
    totalPage: Number,   // 总页数
    pageNumber: Number,  // 当前的页数
  },
  data() {
    return {
      pagination: {
        pageSize: this.pageSize,
        pageNumber: this.pageNumber
      },
      options: [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 }
      ]
    }
  },
  watch: {
    pageSize: function(value) {
      this.pagination.pageSize = value
    },
    pageNumber: function(value) {
      this.pagination.pageNumber = value
    }
  },
  methods: {
    handlePageSizeChange() {
      this.$emit(EVENT_PAGING, {
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.pageNumber,
      })
    },
    handlePageNumberChange() {
      this.$emit(EVENT_PAGING, {
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.pageNumber,
      })
    }
  }
}
</script>

<style scoped>
.text-algin{
  text-align: center;
}
::v-deep .el-pagination.is-background>.el-pager li{
  color: #858582;
  width: 36px;
  height: 36px;
  line-height: 38px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 100;
  background-color: #F2F2ED;
  box-shadow: -2px -2px 3px #FDFDF8,
            4px 4px 4px #E8E8DA;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
  border: 1.5px solid #F2F2ED !important;
  background: linear-gradient(to top left,#FFFFFA,#E8E6DC);
  box-shadow: -2px -2px 3px #FDFDF8,
            4px 4px 4px #E8E8DA;
  /* box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
    4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset; */
  color: #329CA6;
}

::v-deep .el-pagination.is-background .el-pager li {
  margin: 0 10px !important;
}

::v-deep .btn-quicknext {
  pointer-events: none;
}

::v-deep .btn-quickprev {
  pointer-events: none;
}

::v-deep .el-icon-more:before {
  pointer-events: none;
  content: "";
}

::v-deep .el-icon-d-arrow-right::before {
  pointer-events: none;
  content: "";
}

::v-deep .btn-quicknext {
  box-shadow: none !important;
}

::v-deep .btn-quickprev {
  box-shadow: none !important;
}

::v-deep .el-pagination.is-background .el-pager .number {
  line-height: 38px !important;
}
/* ::v-deep .el-icon-more:before {
  content:'';
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyIiB2aWV3Qm94PSIwIDAgMTQgMiI+DQogIDxnIGlkPSLnu4RfMTA3NzMiIGRhdGEtbmFtZT0i57uEIDEwNzczIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzQzIC0xMzQ3KSI+DQogICAgPGcgaWQ9IuakreWchl8xMjQ4IiBkYXRhLW5hbWU9IuakreWchiAxMjQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NDMgMTM0NykiIGZpbGw9IiM3MDcwNzAiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLXdpZHRoPSIxIj4NCiAgICAgIDxjaXJjbGUgY3g9IjEiIGN5PSIxIiByPSIxIiBzdHJva2U9Im5vbmUiLz4NCiAgICAgIDxjaXJjbGUgY3g9IjEiIGN5PSIxIiByPSIwLjUiIGZpbGw9Im5vbmUiLz4NCiAgICA8L2c+DQogICAgPGcgaWQ9IuakreWchl8xMjQ5IiBkYXRhLW5hbWU9IuakreWchiAxMjQ5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NDkgMTM0NykiIGZpbGw9IiM3MDcwNzAiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLXdpZHRoPSIxIj4NCiAgICAgIDxjaXJjbGUgY3g9IjEiIGN5PSIxIiByPSIxIiBzdHJva2U9Im5vbmUiLz4NCiAgICAgIDxjaXJjbGUgY3g9IjEiIGN5PSIxIiByPSIwLjUiIGZpbGw9Im5vbmUiLz4NCiAgICA8L2c+DQogICAgPGcgaWQ9IuakreWchl8xMjUwIiBkYXRhLW5hbWU9IuakreWchiAxMjUwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NTUgMTM0NykiIGZpbGw9IiM3MDcwNzAiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLXdpZHRoPSIxIj4NCiAgICAgIDxjaXJjbGUgY3g9IjEiIGN5PSIxIiByPSIxIiBzdHJva2U9Im5vbmUiLz4NCiAgICAgIDxjaXJjbGUgY3g9IjEiIGN5PSIxIiByPSIwLjUiIGZpbGw9Im5vbmUiLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0K) no-repeat;
  width:27px;
  float:left;
  height:28px;
  cursor:pointer;
} */

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  line-height: 35px !important
}
</style>
